(function () {
	"use strict";
	api = window.api;
})();


function validatePhone(evt) {
	var theEvent = evt || window.event;
	// Handle paste
	if (theEvent.type === 'paste') {
		key = event.clipboardData.getData('text/plain');
	} else {
		// Handle key press
		var key = theEvent.keyCode || theEvent.which;
		key = String.fromCharCode(key);
	}
	var regex = /[0-9]|\./;
	if (!regex.test(key)) {
		theEvent.returnValue = false;
		if (theEvent.preventDefault) theEvent.preventDefault();
	}
}

function validateEmail(email) {
	var re = /\S+@\S+\.\S+/;
	return re.test(email);
}

function selectPackage(packageEl) {
	$(".package").removeClass("package-selected");

	packageEl.classList.add("package-selected");
}

function openFeatures(event, packageId) {
	// Make sure form does not submit on button click
	event.preventDefault();
	event.stopPropagation();

	$('#features-package-' + packageId).modal();
}

$('#RegisterBtn').on("click",
	function (event) {
		event.preventDefault();
		event.stopPropagation();

		$("#RegisterBtn").prop('disabled', true);
		$("#fname_req").slideUp('fast');
		$("#fname").removeClass('error');
		$("#name_req").slideUp('fast');
		$("#name").removeClass('error');
		$("#email_req").slideUp('fast');
		$("#email_inv").slideUp('fast');
		$("#email_used").slideUp('fast');
		$("#email").removeClass('error');
		$("#company_req").slideUp('fast');
		$("#company").removeClass('error');
		if ($("#fname").val() == '') {
			$("#fname").addClass('error');
			$("#fname_req").slideDown('fast');
			$("#RegisterBtn").prop('disabled', false);
			return false;
		}
		if ($("#name").val() == '') {
			$("#name").addClass('error');
			$("#name_req").slideDown('fast');
			$("#RegisterBtn").prop('disabled', false);
			return false;
		}
		if ($("#email").val() == '') {
			$("#email").addClass('error');
			$("#email_req").slideDown('fast');
			$("#RegisterBtn").prop('disabled', false);
			return false;
		}
		var email = $("#email").val();
		if (!validateEmail(email)) {
			$("#email").addClass('error');
			$("#email_inv").slideDown('fast');
			$("#RegisterBtn").prop('disabled', false);
			return false;
		}

		if ($("#phone").length) {
			$("#phone_req").slideUp('fast');
			$("#phone").removeClass('error');
			if ($("#phone").val() == '') {
				$("#phone").addClass('error');
				$("#phone_req").slideDown('fast');
				$("#RegisterBtn").prop('disabled', false);
				return false;
			} else {
				var flphpone = $("#phone").intlTelInput("getNumber");
				$("#FullPhone").val(flphpone);
			}
		}
		if ($("#company").val() == '') {
			$("#company").addClass('error');
			$("#company_req").slideDown('fast');
			$("#RegisterBtn").prop('disabled', false);
			return false;
		}
		if ($("#country").length) {
			$("#country_req").slideUp('fast');
			$("#country").removeClass('error');
			if ($("#country").val() == '' || $("#country").val() == '0') {
				$("#country").addClass('error');
				$("#country_req").slideDown('fast');
				$("#RegisterBtn").prop('disabled', false);
				return false;
			}
		}

		grecaptcha.ready(function () {
			grecaptcha.execute('6LefrqYZAAAAAAQboruE0-hqcuWutDnl4A6MiOm9', {
				action: 'apiform'
			}).then(function (token) {
				$('#signup').prepend('<input type="hidden" name="g-recaptcha-response" value="' + token + '">');
				$.post("Captcha.php", {
					token: token
				}, function (result) {
					if (result.success) {
						var formcode = $("#formcode").val();
						var dataform = $("#signup").serialize();

						let packageId = getSelectedPackage();

						if (packageId) dataform += "&package=pac_" + packageId;

						$.ajax({
							type: "POST",
							url: "signup.php",
							data: dataform + "&fc=" + formcode,
							dataType: "json",
							cache: false,
						}).done(function (data) {
							if (data.success) {
								$("#CustomInt").html(data.customint);
								$("#signup").hide('fast');
								$("#Extra").hide('fast');
								$("#signupHead").hide('fast');
								$("#validForm").slideDown('fast');
							} else {
								$("#Extra").hide('fast');
								$("#signup").hide('fast');
								$("#signupHead").hide('fast');
								$("#RegisterBtn").prop('disabled', false);
							}
						}).catch((data) => {
							let response = data.responseJSON;

							if (response.error_codes.includes(305)) {
								$("#email").addClass('error');
								$("#email_inv").slideDown('fast');
							} else if (response.error_codes.includes(304)) {
								$("#email").addClass('error');
								$("#email_used").slideDown('fast');
							}
						}).always(() => {
							$("#RegisterBtn").prop('disabled', false);
						});
					}
				});
			});
		});

	}
);

function getSelectedPackage() {
	let packages = $(".package.package-selected");

	if (packages.length == 0) return null;

	let id = $(".package.package-selected")[0].id;

	return id.split("-")[1];
}
